export const parseEnv = (value: unknown): string | undefined => {
  return typeof value === 'string' && value !== '' ? value : undefined
}
